import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "isLoading", "sortType", "searchString", "isEmptyPopularBtn", "welcomeText", "dispatch", "isLastSessionFinished", "systemProblems"];
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { cnBem } from "../../../../shared/lib";
import { Divider } from "../../../../shared/ui";
import { QuickActions } from "../../../../features/quick-actions/ui";
import { useGroupedMessages, useStickyDividers } from "../../lib";
import { Notifications } from "../../../../features/notifications/ui";
import { selectFrequentQuestions, selectSystemProblemInternet, selectWelcomeText } from "../../../../entities/content/model";
import { selectIsLastSessionFinished, selectIsLoading } from "../../../../entities/message/model";
import { selectSearch, selectSortType } from "../../../../entities/filters/model";
import { useScrollContext } from "../../../../shared/model";
import { useNotificationContext } from "../../../../entities/notification/model";
import { SYSTEM_PROBLEM_NOTIFICATION_KEY } from "../../../../features/notifications/lib";
import { selectStartButtons } from "../../../../entities/settings/model";
import { MessageGroup } from "../MessageGroup";
import styles from "./styles.pcss";
import { SkeletonList } from "../SkeletonList";
var cnMessageList = cnBem('message-list', styles);
var defaultWelcomMessage = 'В любой непонятной ситуации пишите сюда';
var MessageListRender = function MessageListRender(props) {
  var className = props.className,
    isLoading = props.isLoading,
    sortType = props.sortType,
    searchString = props.searchString,
    isEmptyPopularBtn = props.isEmptyPopularBtn,
    welcomeText = props.welcomeText,
    _dispatch = props.dispatch,
    isLastSessionFinished = props.isLastSessionFinished,
    systemProblems = props.systemProblems,
    otherProps = _objectWithoutProperties(props, _excluded);
  var groupedMessages = useGroupedMessages();
  var _useStickyDividers = useStickyDividers(groupedMessages),
    dividerRefs = _useStickyDividers.dividerRefs,
    sessionSectionRefs = _useStickyDividers.sessionSectionRefs;
  var _useScrollContext = useScrollContext(),
    containerRef = _useScrollContext.containerRef,
    onListMount = _useScrollContext.onListMount;
  var _useNotificationConte = useNotificationContext(),
    addNotification = _useNotificationConte.addNotification,
    removeNotification = _useNotificationConte.removeNotification;
  var showStarMessage = !isLoading && groupedMessages.length === 0 && !(searchString !== null && searchString !== void 0 && searchString.trim());
  var isOnlyStartMessage = isLastSessionFinished && isEmptyPopularBtn && showStarMessage;
  useEffect(function () {
    if (!isLoading) {
      onListMount();
    }
  }, [isLoading]);
  useEffect(function () {
    if (isLastSessionFinished && systemProblems !== null && systemProblems !== void 0 && systemProblems.content) {
      addNotification({
        key: SYSTEM_PROBLEM_NOTIFICATION_KEY,
        label: systemProblems.content,
        mode: 'button',
        view: 'warning'
      });
    } else {
      removeNotification(SYSTEM_PROBLEM_NOTIFICATION_KEY);
    }
  }, [isLastSessionFinished, systemProblems]);
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnMessageList({
      empty: isOnlyStartMessage
    }, [className]),
    ref: containerRef
  }, otherProps), isLoading ? /*#__PURE__*/React.createElement(SkeletonList, null) : /*#__PURE__*/React.createElement(React.Fragment, null, groupedMessages.map(function (group, i) {
    return /*#__PURE__*/React.createElement(MessageGroup, _extends({
      dividerRef: dividerRefs[i],
      key: cnMessageList('group', {
        i: i
      }),
      ref: sessionSectionRefs[i]
    }, group));
  }), showStarMessage && /*#__PURE__*/React.createElement(Divider, {
    label: welcomeText || defaultWelcomMessage,
    view: "default"
  })), /*#__PURE__*/React.createElement(QuickActions, {
    className: cnMessageList('actions')
  }), /*#__PURE__*/React.createElement(Notifications, null));
};
var mapStateToProps = function mapStateToProps(store) {
  var _selectStartButtons;
  return {
    isLoading: selectIsLoading(store),
    searchString: selectSearch(store),
    sortType: selectSortType(store),
    welcomeText: selectWelcomeText(store),
    systemProblems: selectSystemProblemInternet(store),
    isLastSessionFinished: selectIsLastSessionFinished(store),
    isEmptyPopularBtn: !(selectFrequentQuestions(store).length || (_selectStartButtons = selectStartButtons(store)) !== null && _selectStartButtons !== void 0 && _selectStartButtons.length)
  };
};
export var MessageList = connect(mapStateToProps)(MessageListRender);